import Head from "next/head";

import { useStakeProvider } from "dapp-sdk";

import DeFiPage from "@container/pages/Defi";
import Sidebar from "@components/Sidebar";
import Header from "@components/Header";
import PageLayout from "@components/PageLayout";

import { fetchPageData } from "@utils/globalCommon";
import { PageProvider } from "@providers/PageProvider";

interface PageProps {
  page: any;
  shouldDisplayBanner: boolean;
}

const PageHead = () => {
  return (
    <Head>
      <title>DeFi | Stader</title>
    </Head>
  );
};

const DefiPage = ({ page, shouldDisplayBanner }: PageProps) => {
  const { setMobileMenuVisible } = useStakeProvider();
  if (process.env.NEXT_PUBLIC_TOKEN === "ETH") {
    // TODO replace with 404 page
    return null;
  }
  return (
    <>
      <PageHead />
      <PageProvider page={page}>
        <PageLayout
          Sidebar={
            <Sidebar
              display={{ base: "none", xl: "block" }}
              minH={{
                base: "100vh",
                xl: shouldDisplayBanner ? "calc(100vh - 32px)" : "100vh",
              }}
            />
          }
          MobileSideBar={
            <Sidebar setMobileMenuVisible={setMobileMenuVisible} />
          }
          Header={<Header />}
        >
          <DeFiPage />
        </PageLayout>
      </PageProvider>
    </>
  );
};

export async function getStaticProps() {
  const [resJson, defiData] = await Promise.all([
    fetchPageData(
      "liquid-staking-pages",
      Number(process.env.NEXT_PUBLIC_STRAPI_ID || 0)
    ),
    fetchPageData(
      "defi-pages",
      undefined,
      `filters[key][$eq]=${process.env.NEXT_PUBLIC_TOKEN?.toLowerCase() || ""}`
    ),
  ]);

  const pageData = resJson.data?.attributes || null;
  const pageError = resJson.error || null;
  return {
    props: {
      page: {
        data: {
          ...pageData,
        },
        defiData: defiData?.data[0]?.attributes || {},
        error: pageError,
      },
    },
  };
}

export default DefiPage;
